import module from 'fanconsultores/module.js'
import template from './template.html'
import './style.scss'

class FanconsultoresSharedLogoComponent {
}

module.component('fanconsultoresSharedLogo', {
  controller: FanconsultoresSharedLogoComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/shared/logo/component.js